import React, { createContext, useContext, useState } from 'react';
import { doc, setDoc, getDoc } from 'firebase/firestore'; 
import { db, appId } from '../firebase/config';

const EditorContext = createContext();

export const useEditor = () => useContext(EditorContext);

export const EditorProvider = ({ children }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedElement, setSelectedElement] = useState(null);
    const [themeData, setThemeData] = useState({});
    
    // NOVIDADE: Modo de Visualização (Desktop ou Mobile)
    const [viewMode, setViewMode] = useState('desktop'); 

    const toggleEditMode = () => {
        setIsEditMode(prev => !prev);
        if (isEditMode) {
            setSelectedElement(null);
            setViewMode('desktop'); // Reset ao sair
        }
    };

    const saveDraft = async (collection, docId, data) => {
        if (!appId) return;
        try {
            const ref = doc(db, `artifacts/${appId}/public/data/${collection}`, `${docId}_draft`);
            await setDoc(ref, data, { merge: true });
            
            // Atualizar estado local para refletir mudanças imediatas
            if (collection === 'configuracoes' && docId === 'tema') {
                setThemeData(prev => ({ ...prev, ...data }));
            }
        } catch (error) {
            console.error("Erro ao gravar rascunho:", error);
        }
    };

    const publishChanges = async () => {
        // Lógica de publicação (simplificada para o exemplo)
        // Copiaria de _draft para live
        console.log("A publicar alterações...");
    };

    return (
        <EditorContext.Provider value={{ 
            isEditMode, 
            toggleEditMode, 
            selectedElement, 
            setSelectedElement, 
            saveDraft, 
            publishChanges,
            themeData,
            setThemeData,
            // Exportar as novas variáveis
            viewMode,
            setViewMode
        }}>
            {children}
        </EditorContext.Provider>
    );
};